import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { MembershipHeader } from './components';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Container, Grid, Link, TextField, Typography, useMediaQuery } from "@material-ui/core";
import { actionGetMemberValidation, actionResetMemberValidation, actionSetErrorMemberValidation, actionResetCustomer, actionGetMembershipPackages } from 'actions';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import { actionSendEmail, actionResetSendEmail } from 'actions';
import ProcessingBox from '../Checkout/components/ProcessingBox';

const { MembershipPackagesDisplayAreaNo, TitleforloadingSendLostMemberemail, Subtitle1forloadingSendLostMemberemail, Subtitle2forloadingSendLostMemberemail, PhoneOrAddress1ForMemberValidate } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
}));

const MemberValidation = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const isSmScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));

    const membershippackagesreducer = useSelector(state => state.reducerMembershipPackages);
    let membershipPackage = membershippackagesreducer.membershipPackage;
    const memberValidationReducer = useSelector(state => state.reducerMemberValidation);
    const reducerLostMember = useSelector(state => state.reducerLostMember);
    const customer = useSelector(state => state.reducerCustomer);
    const reducerMembershipPackages = useSelector(state => state.reducerMembershipPackages);

    const [showMainValidate, setshowMainBalidate] = React.useState(false);
    const [showProgBox, setshowProgBox] = React.useState(false);
    const [showMainValidateAllFields, setshowMainValidateAllFields] = React.useState(false);
    const [errorMsg, seterrorMsg] = React.useState('');

    useEffect(() => {

        if (reducerMembershipPackages && reducerMembershipPackages.membershippackages && reducerMembershipPackages.membershippackages.length == 0) {
            actionGetMembershipPackages(dispatch, MembershipPackagesDisplayAreaNo);
        }

    }, []);

    if (memberValidationReducer.membervalidation && memberValidationReducer.membervalidation.MemberValidation && memberValidationReducer.membervalidation.MemberValidation[0].hasOwnProperty("EmailMatched")) {

        if (!memberValidationReducer.membervalidation.MemberValidation[0].EmailMatched
            && memberValidationReducer.membervalidation.MemberValidation[0].AddressMatched == undefined &&
            memberValidationReducer.membervalidation.MemberValidation[0].PhoneMatched == undefined) {
            actionSetErrorMemberValidation(dispatch, 'Email does not match.');
            setshowMainValidateAllFields(true);
        }

        if (showMainValidateAllFields) {
            if ((memberValidationReducer.membervalidation.MemberValidation[0].PhoneMatched == undefined || memberValidationReducer.membervalidation.MemberValidation[0].PhoneMatched == false)
                && (memberValidationReducer.membervalidation.MemberValidation[0].AddressMatched == undefined || memberValidationReducer.membervalidation.MemberValidation[0].AddressMatched == false)) {
                actionSetErrorMemberValidation(dispatch, 'Phone or Address 1 does not match.');
                setshowMainValidateAllFields(true);
            }
        }
    }

    useEffect(() => {
        if (reducerLostMember.emailsend || reducerLostMember.lostmemberError.length > 0) {
            setshowProgBox(false);
        }
    }, [reducerLostMember])

    useEffect(() => {
        if (memberValidationReducer.membervalidation && memberValidationReducer.membervalidation.MemberValidation && validationfields.email && validationfields.email.trim().length > 0) {

            props.history.push({
                pathname: '/memberships',
                emailaddress: validationfields.email
            })
        }
    }, [memberValidationReducer.membervalidation]);

    const [validationfields, setvalidationfields] = React.useState({
        lastName: '',
        email: '',
        memberNo: '',
        phone: '',
        address1: ''
    });

    //Intialize States
    const [errorstate, seterrorstate] = React.useState({
        initialerrorstate: {
            last_name: {
                errorstate: false,
                errortext: ""
            },
            email: {
                errorstate: false,
                errortext: ""
            },
            member_no: {
                errorstate: false,
                errortext: ""
            },
            phone: {
                errorstate: false,
                errortext: ""
            },
            address1: {
                errorstate: false,
                errortext: ""
            }
        }
    });

    const fieldhandleChange = (event) => {

        if (event.target.name === "lname") {
            setvalidationfields({ ...validationfields, lastName: event.target.value });
        }

        if (event.target.name === "email") {
            setvalidationfields({ ...validationfields, email: event.target.value });
        }

        if (event.target.name === "memberno") {
            setvalidationfields({ ...validationfields, memberNo: event.target.value });
        }

        if (event.target.name === "phone") {
            setvalidationfields({ ...validationfields, phone: event.target.value });
        }


        if (event.target.name === "address1") {
            setvalidationfields({ ...validationfields, address1: event.target.value });
        }
    }


    const ValidateMember = () => {

        var valFields = { ...validationfields };
        var initialerrstate = { ...errorstate.initialerrorstate };


        if (valFields.lastName.trim().length < 1) {
            initialerrstate.last_name.errorstate = true;
            initialerrstate.last_name.errortext = "Last Name is required.";
            seterrorstate({ ...errorstate, initialerrstate });
        }
        else {
            initialerrstate.last_name.errorstate = false;
            initialerrstate.last_name.errortext = "";
            seterrorstate({ ...errorstate, initialerrstate });
        }


        if (showMainValidateAllFields == false) {
            if (valFields.email.trim().length < 1) {
                initialerrstate.email.errorstate = true;
                initialerrstate.email.errortext = "Email is required.";
                seterrorstate({ ...errorstate, initialerrstate });
            }
            else {
                initialerrstate.email.errorstate = false;
                initialerrstate.email.errortext = "";
                seterrorstate({ ...errorstate, initialerrstate });
            }
        }


        if (valFields.memberNo.trim().length < 1) {
            initialerrstate.member_no.errorstate = true;
            initialerrstate.member_no.errortext = "Member No is required.";
            seterrorstate({ ...errorstate, initialerrstate });
        }
        else {
            initialerrstate.member_no.errorstate = false;
            initialerrstate.member_no.errortext = "";
            seterrorstate({ ...errorstate, initialerrstate });
        }

        if (showMainValidateAllFields) {

            if (valFields.phone.trim().length < 1 && valFields.address1.trim().length < 1) {
                initialerrstate.phone.errorstate = true;
                initialerrstate.phone.errortext = "Phone No is missing.";

                initialerrstate.address1.errorstate = true;
                initialerrstate.address1.errortext = "Address 1 is missing.";

                seterrorstate({ ...errorstate, initialerrstate });
            }
            else {
                initialerrstate.phone.errorstate = false;
                initialerrstate.phone.errortext = "";
                initialerrstate.address1.errorstate = false;
                initialerrstate.address1.errortext = "";
                seterrorstate({ ...errorstate, initialerrstate });
            }


            if (valFields.lastName.trim().length > 0 && valFields.memberNo.trim().length > 0 && (valFields.phone.trim().length > 0 || valFields.address1.trim().length > 0)) {
                actionGetMemberValidation(dispatch, validationfields.memberNo, validationfields.lastName, '', validationfields.phone, validationfields.address1);
            }
        }
        else {
            if (valFields.lastName.trim().length > 0 && valFields.lastName.trim().length > 0 && valFields.memberNo.trim().length > 0) {
                actionGetMemberValidation(dispatch, validationfields.memberNo, validationfields.lastName, validationfields.email);
            }
        }
    }

    const errorcancelhandle = () => {
        actionResetMemberValidation(dispatch);

        if (customer.customerError && customer.customerError.length) {
            actionResetCustomer(dispatch);
        }

        seterrorMsg("");
    }

    const errorcancelhandleemail = () => {
        actionResetSendEmail(dispatch);
    }

    const ShowEmailView = () => {
        setshowMainBalidate(true);
        setshowMainValidateAllFields(false);
    }

    const ShowValidateView = () => {
        setshowMainBalidate(false);
        actionResetSendEmail(dispatch);

        setvalidationfields({ ...validationfields, lastName: '' });
        setvalidationfields({ ...validationfields, email: '' });
        setvalidationfields({ ...validationfields, memberNo: '' });
    }

    const SendEmailToCst = () => {

        var valFields = { ...validationfields };
        var initialerrstate = { ...errorstate.initialerrorstate };

        if (valFields.lastName.trim().length < 1) {
            initialerrstate.last_name.errorstate = true;
            initialerrstate.last_name.errortext = "Last Name is required.";
            seterrorstate({ ...errorstate, initialerrstate });
        }
        else {
            initialerrstate.last_name.errorstate = false;
            initialerrstate.last_name.errortext = "";
            seterrorstate({ ...errorstate, initialerrstate });
        }


        if (valFields.email.trim().length < 1) {
            initialerrstate.email.errorstate = true;
            initialerrstate.email.errortext = "Email is required.";
            seterrorstate({ ...errorstate, initialerrstate });
        }
        else {
            initialerrstate.email.errorstate = false;
            initialerrstate.email.errortext = "";
            seterrorstate({ ...errorstate, initialerrstate });
        }


        if (valFields.lastName.trim().length > 0 && valFields.email.trim().length > 0) {
            var request = [{
                "LastName": valFields.lastName,
                "Email": valFields.email
            }]

            setshowProgBox(true);
            actionSendEmail(dispatch, request);
        }

    }

    return (
        <Container id="vt_page_membership_validation" className={classes.root}>
            {/* <div className={classes.root} style={{ width: "80%", margin: "0 auto" }} > */}
            <ErrorHandling msg={memberValidationReducer.membervalidationError.length > 0 ? memberValidationReducer.membervalidationError : ''}
                open={memberValidationReducer.membervalidationError.length > 0 ? true : false} handleclose={errorcancelhandle} />

            <ErrorHandling msg={reducerLostMember.lostmemberError.length > 0 ? reducerLostMember.lostmemberError : ''}
                open={reducerLostMember.lostmemberError.length > 0 ? true : false} handleclose={errorcancelhandleemail} />

            <ErrorHandling msg={errorMsg && errorMsg.length > 0 ? errorMsg : ''}
                open={errorMsg && errorMsg.length > 0 ? true : false} handleclose={errorcancelhandle} />

            <MembershipHeader membershipPackage={membershipPackage} />

            {
                showMainValidateAllFields ?

                    <div style={{ marginTop: '20px' }}>
                        <Typography variant="subtitle2">
                            To find your existing membership, please enter following information to validate.
                        </Typography>

                        <Grid container spacing={1} style={{ marginTop: '10px' }}>
                            <Grid item lg={6} xs={12}  >
                                <TextField
                                    fullWidth
                                    autoFocus
                                    margin="dense"
                                    name="lname"
                                    id="lname"
                                    label="Last Name"
                                    type="text"
                                    required
                                    variant="outlined"
                                    onChange={fieldhandleChange}
                                    value={validationfields.lastName}
                                    error={errorstate.initialerrorstate.last_name.errorstate}
                                    helperText={errorstate.initialerrorstate.last_name.errortext}
                                />
                            </Grid>



                            <Grid item lg={6} xs={12} >
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    name="memberno"
                                    id="memberno"
                                    label="Member #"
                                    type="text"
                                    required
                                    variant="outlined"
                                    onChange={fieldhandleChange}
                                    value={validationfields.memberNo}
                                    error={errorstate.initialerrorstate.member_no.errorstate}
                                    helperText={errorstate.initialerrorstate.member_no.errortext}
                                />

                                <Link href="#" color="primary" underline="always" onClick={ShowEmailView}>
                                    I don't know my member #.
                                </Link>
                            </Grid>

                            <Grid item lg={6} xs={12}  >
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    name="phone"
                                    id="phone"
                                    label="Phone #"
                                    type="text"
                                    value={validationfields.phone}
                                    variant="outlined"
                                    onChange={fieldhandleChange}
                                    error={errorstate.initialerrorstate.phone.errorstate}
                                    helperText={errorstate.initialerrorstate.phone.errortext}
                                />
                            </Grid>



                            <Grid item lg={6} xs={12} >
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    name="address1"
                                    id="address1"
                                    label="Address 1"
                                    type="text"
                                    value={validationfields.address1}
                                    variant="outlined"
                                    onChange={fieldhandleChange}
                                    error={errorstate.initialerrorstate.address1.errorstate}
                                    helperText={errorstate.initialerrorstate.address1.errortext}
                                />
                            </Grid>

                            <Grid item lg={12} xs={12} >
                                <Typography variant="subtitle2" color="textSecondary" align="center">{PhoneOrAddress1ForMemberValidate}</Typography>
                            </Grid>
                            <Grid item lg={12} xs={12} align='center'>

                                <Button color="primary" variant="contained" onClick={ValidateMember} style={{ marginTop: "6px", width: (isSmScreen ? '100%' : '50%') }}>
                                    Find Existing Details
                                </Button>

                            </Grid>
                        </Grid>
                    </div>
                    :
                    <div>
                        {showMainValidate ?
                            <div style={{ marginTop: '20px' }}>

                                <Typography variant="subtitle2">
                                    Can't remember your member #? Please enter your last name + email and we'll send you an email with the member number to verify and renew.
                                </Typography>

                                <Grid container spacing={1} >
                                    <Grid item lg={4} sm={12} xs={12}  >
                                        <TextField
                                            fullWidth
                                            autoFocus
                                            margin="dense"
                                            name="lname"
                                            id="lname"
                                            label="Last Name"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.last_name.errorstate}
                                            helperText={errorstate.initialerrorstate.last_name.errortext}
                                        />
                                    </Grid>

                                    <Grid item lg={4} sm={12} xs={12}  >
                                        <TextField
                                            fullWidth
                                            margin="dense"
                                            name="email"
                                            id="email"
                                            label="Email"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.email.errorstate}
                                            helperText={errorstate.initialerrorstate.email.errortext}
                                            inputProps={{ "data-hj-allow": "" }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} >

                                        <Button fullWidth={true} color="primary" variant="contained" onClick={SendEmailToCst} style={{ marginTop: "7px" }}>
                                            Send Mail
                                        </Button>

                                    </Grid>
                                    {!reducerLostMember.emailsend ? <Grid alignItems='center' lg={4} xs={12} style={{ minHeight: 200, marginTop: (showProgBox ? 200 : -200) }}>
                                        <ProcessingBox isshow={showProgBox} title={TitleforloadingSendLostMemberemail} text1={Subtitle1forloadingSendLostMemberemail} text2={Subtitle2forloadingSendLostMemberemail} ></ProcessingBox>
                                    </Grid>
                                        : null}

                                    {reducerLostMember.emailsend ?
                                        <div style={{ width: "100%", margin: "0 auto" }} >
                                            <Typography variant="h5" >
                                                Email sent successfully!
                                            </Typography>
                                            <Grid item lg={12} sm={12} xs={12}>
                                                <Button color="primary" variant="contained" size="large" onClick={ShowValidateView}>
                                                    Back to Renew
                                                </Button>
                                            </Grid>
                                        </div> : null}
                                </Grid>

                            </div> :
                            <div style={{ marginTop: '20px' }}>
                                <Typography variant="subtitle2">
                                    To find your existing membership, please enter following information to validate.
                                </Typography>

                                <Grid container spacing={1} >
                                    <Grid item lg={3} xs={12}  >
                                        <TextField
                                            fullWidth
                                            autoFocus
                                            margin="dense"
                                            name="lname"
                                            id="lname"
                                            label="Last Name"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.last_name.errorstate}
                                            helperText={errorstate.initialerrorstate.last_name.errortext}
                                        />
                                    </Grid>

                                    <Grid item lg={3} xs={12}  >
                                        <TextField
                                            fullWidth
                                            margin="dense"
                                            name="email"
                                            id="email"
                                            label="Email"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.email.errorstate}
                                            helperText={errorstate.initialerrorstate.email.errortext}
                                            inputProps={{ "data-hj-allow": "" }}
                                       />
                                    </Grid>

                                    <Grid item lg={3} xs={12} >
                                        <TextField
                                            fullWidth
                                            margin="dense"
                                            name="memberno"
                                            id="memberno"
                                            label="Member #"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.member_no.errorstate}
                                            helperText={errorstate.initialerrorstate.member_no.errortext}
                                        />

                                        <Link href="#" color="primary" underline="always" onClick={ShowEmailView}>
                                            I don't know my member #.
                                        </Link>
                                    </Grid>

                                    <Grid item lg={3} xs={12} >
                                        <Button fullWidth={true} color="primary" variant="contained" onClick={ValidateMember} style={{ marginTop: "6px" }}>
                                            Find Existing Details
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        }
                    </div>
            }
            {/* </div > */}
        </Container>
    );
};

export default MemberValidation;
